"use strict";
/**
 * Plans, subscriptions, seats and the entitlements derived from them.
 *
 * The chain is deliberately three links long. A plan says what a tier includes;
 * a subscription says an org bought one and until when; a seat says which
 * member it covers. School Membership in the outline is "unlimited teacher
 * accounts", which is a subscription with a large seat count — not a different
 * kind of thing, and not a different code path.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENTITLING_STATUSES = exports.SUBSCRIPTION_STATUSES = exports.FEATURES = exports.PLAN_CODES = void 0;
exports.PLAN_CODES = ['free', 'professional', 'school', 'institutional'];
/**
 * Feature keys a plan can include.
 *
 * Named after what they unlock rather than after the plan that carries them,
 * so moving a feature between tiers is a data change. `@RequiresEntitlement`
 * takes one of these.
 */
exports.FEATURES = [
    'course.premium',
    'lab.premium',
    'resource.premium',
    'certificate.issue',
    'community.premium',
    'analytics.org',
    'analytics.subtree',
    'analytics.export',
    'ai.tools',
    'offline.download',
];
exports.SUBSCRIPTION_STATUSES = [
    'trialing',
    'active',
    'past_due',
    'cancelled',
    'expired',
];
/** Statuses that actually entitle. Everything else gates. */
exports.ENTITLING_STATUSES = ['trialing', 'active'];
//# sourceMappingURL=billing.js.map